import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import '../JobOnboarding/JobOnboarding.css'
import { Input } from "formik-antd";
import moment from 'moment';
import DummyUploadImage from "../../assets/images/upload-image4.svg";
import api from '../../services/api';
import endpoints from '../../services/endpoints';
import Loader from '../../components/Loader';
import Loader2 from '../../components/loader2';
import SuccessPopup from "../../components/SuccessPopup";
import ErrorWindow from "../../components/ErrorWindow";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import '../../styles/home-user-landing-page.css';
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

const mediaInitialState = [null, null, null, null];


const TabJobDetail = ({ jobId, duplicate }) =>
{
  const fileInputRefs = useRef([null, null, null, null]);
  const [jobsdata, setJobsdata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isInsideLoading, setIsInsideLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadedImages, setUploadedImages] = useState(mediaInitialState);
  const [successPopup, setSuccessPopup] = useState(false);
  const [isErrorWindow, setIsErrorWindow] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [date, setDate] = useState(null);
  const [optionError, setOptionError] = useState('');
  const [searchTerm, setSearchTerm] = useState(null);
  const [results, setResults] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [fieldValue, setFieldValue] = useState([]);
  const MAX_RESULTS = 30;

  const navigate = useNavigate();

  console.log("jobid:", jobId);


  const GetJobById = async () =>
  {
    setIsInsideLoading(true);
    try
    {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/getjobbyid?id=${jobId}`);
      setJobsdata(response.data);
      setSelectedOption(response.data.deadline);

      const images = [
        response.data.image1 ? { file: null, url: response.data.image1 } : null,
        response.data.image2 ? { file: null, url: response.data.image2 } : null,
        response.data.image3 ? { file: null, url: response.data.image3 } : null,
        response.data.image4 ? { file: null, url: response.data.image4 } : null
      ];

      setUploadedImages(images);
      setFieldValue(response.data.profession);
      console.log("job detail img", uploadedImages);

      setIsInsideLoading(false);

    } catch (error)
    {
      setIsInsideLoading(false);
      setError(error.message);
    } finally
    {
      setIsInsideLoading(false);
    }
  };


  const handleOptionClick = (option) =>
  {
    setSelectedOption(option);
    if (option !== "Pick a Date")
    {
      setDate(null);
    }
  };


  const handleFileChange = (file) =>
  {
    if (file)
    {
      const newImageUrl = URL.createObjectURL(file);
      const newUploadedImages = [...uploadedImages];

      const emptyIndex = newUploadedImages.findIndex(img => img === null);

      if (emptyIndex !== -1)
      {
        newUploadedImages[emptyIndex] = { file, url: newImageUrl };
        setUploadedImages(newUploadedImages);
        console.log("newv upload img", uploadedImages);

      } else
      {
        alert("You can only upload up to four images.");
      }
    }
  };

  const handleDragOver = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragEnter = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) =>
  {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0)
    {
      const file = e.dataTransfer.files[0];
      handleFileChange(file);
      e.dataTransfer.clearData();
    }
  };

  const handleFileSelectClick = () =>
  {
    if (fileInputRefs.current)
    {
      fileInputRefs.current.click();
    }
  };

  const handleGoBack = () => {
    navigate('/JobsDashboard');
  };


  const SaveChanges = async (values) =>
  {
    const token = localStorage.getItem('token');
    if (token)
    {
      const decodetoken = jwtDecode(token);
      const homeUserId = decodetoken.nameid;
      const params = {
        userId: homeUserId,
        job_id: duplicate === 0 ? jobId : 0,
        name: values?.name,
        postcode: values?.postcode,
        profession: values?.profession,
        description: values?.description,
        budgetAmount: values?.budgetAmount,
        budget: values?.budget,
        deadlineDate: values?.deadlineDate,
        deadline: values?.deadline,
        siteVisit: values?.siteVisit,
        image1: !uploadedImages[0]?.file ? uploadedImages[0]?.url?.replace(/^https?:\/\/[^/]+\//, "/") : "",
        image2: !uploadedImages[1]?.file ? uploadedImages[1]?.url?.replace(/^https?:\/\/[^/]+\//, "/") : "",
        image3: !uploadedImages[2]?.file ? uploadedImages[2]?.url?.replace(/^https?:\/\/[^/]+\//, "/") : "",
        image4: !uploadedImages[3]?.file ? uploadedImages[3]?.url?.replace(/^https?:\/\/[^/]+\//, "/") : "",
        jobStatus: "Open",
        created_at: jobsdata?.created_at,
        isPublish: values?.isPublish,
        updated_at: new Date().toISOString(),
        isDuplicate: values?.isDuplicate,
      }
      try
      {
        if (duplicate === 0)
        {

          const response = await axios.post(`${API_BASE_URL}/${endpoints.updateJob}?id=${jobId}`, params);
          await UploadImage(jobId);
        } else
        {
          params.isDuplicate = true;
          const response = await axios.post(`${API_BASE_URL}/${endpoints.createJob}?id=${jobId}`, params);
          let JOBID = response.data.job_id;
          await UploadImage(JOBID);
        }
        setIsLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Job Saved Successfully !!',
          text: 'Your job has been successfully saved to the list. You can now review it anytime!',
          timer: 2000,
          showConfirmButton: false,
          customClass: "confirmation-popup"
        }).then(() =>
        {
          navigate('/JobsDashboard');
        });
        // setSuccessPopup(true);
      } catch (error)
      {
        setIsLoading(false);
        setIsErrorWindow(true);
      } finally
      {
        setIsLoading(false);
      }
    }
  }

  const handleSearchChange = async (e) =>
  {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);

    if (searchValue.length > 0)
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/ProfessionSearch/searchprofessions?search=${searchValue}`);
        setResults(response.data.slice(0, MAX_RESULTS));
        setDropdownOpen(true);
      } catch (error)
      {
        console.error('Error fetching professions:', error);
      }
    } else
    {
      setResults([]);
      setDropdownOpen(false);
    }
  };


  const UploadImage = async (jobId) =>
  {
    try
    {
      if (!jobId || uploadedImages.length === 0)
      {
        console.error("Invalid jobId or no images selected.");
        return;
      }

      const formData = new FormData();
      uploadedImages.forEach(image =>
      {
        if (image && image.file)
        {
          formData.append("files", image.file);
        }
      });
      if (uploadedImages.length > 0)
        await api.post(`${API_BASE_URL}/api/Jobs/upload/${jobId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

      setIsLoading(false);

    } catch (error)
    {
      console.error("Error during job creation or image upload:", error);
    } finally
    {
      setIsLoading(false);
    }
  };

  const closeSuccessPopup = () =>
  {
    setSuccessPopup(false);
    navigate("/JobsDashboard");
  };

  const closeErrorWindow = () =>
  {
    setIsErrorWindow(false);
  };

  useEffect(() =>
  {
    setIsInsideLoading(true);
    GetJobById();
    setTimeout(() =>
    {
      console.log("jons data", jobsdata);
    }, 1000);
  }, []);

  const handleRemoveFile = (image, index) =>
  {
    const updatedImages = [...uploadedImages];
    updatedImages[index] = null;
    const filledImages = updatedImages.filter(img => img !== null);
    const newImages = [...filledImages, ...Array(4 - filledImages.length).fill(null)];
    setUploadedImages(newImages);
  };

  const handleClear = () =>
  {
    setSearchTerm('');
    setResults([]);
    setDropdownOpen(false);
  };

  useEffect(() =>
  {
    const handleClickOutside = (event) =>
    {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target))
      {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
    {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <>
      <div className='tab-content-wrap'>
        <div className='tab-content'>
          <div className='tab-section-left'>
            <Formik
              initialValues={{
                ...jobsdata,
                // profession: []
                // ...details,
                // ...timeBudget,
                // ...uploadedImages
              }}
              enableReinitialize={true}
              onSubmit={(values) =>
              {
                if (selectedOption === "")
                {
                  setOptionError("Please Select One");
                  setIsLoading(true);
                  setTimeout(() =>
                  {
                    SaveChanges(values);
                  }, 1000);
                } else
                {
                  setIsLoading(true);
                  SaveChanges({
                    ...values,
                    deadline: selectedOption,
                  });
                  // SaveChanges(prevState => ({
                  //   ...prevState,
                  //   ...values,  // Merge the existing values with the updated state
                  //   deadline: selectedOption, // Set the selected option as the deadline
                  // }));
                }
              }}
              validate={(values) =>
              {
                const errors = {};

                if (!values.name)
                {
                  errors.name = "Title is required";
                }
                if (!values.postcode)
                {
                  errors.postcode = "Postcode is required";
                }
                if (!values.description)
                {
                  errors.description = "Job Description is required";
                }

                if (!values.budgetAmount)
                {
                  errors.budgetAmount = "Address is required";
                }
                if (!values.budget)
                {
                  errors.budget = "Please Select Budget";
                }
                if (!values.deadline)
                {
                  errors.deadline = "Please Select One";
                }
                if (!values.siteVisit)
                {
                  errors.siteVisit = "Please Select Site Visit Time";
                }

                return errors;
              }}
            >
              {({ handleSubmit, handleChange, values, errors, touched }) => (
                <form onSubmit={handleSubmit}>
                  {/* Job Details Section */}
                  <section className="onboarding-form">
                    <div class="container">
                      {isInsideLoading &&
                        <div className="loader-div">
                          <Loader2 />
                        </div>
                      }
                      {!isInsideLoading && (
                        <>
                          <div className="form-main" >
                            <div className='form-row'>
                              <div className="form-group">
                                <label>Add Profession Categories</label>
                                <div className="form-control-wrapper">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Profession search"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    onFocus={() => setDropdownOpen(true)}
                                  />
                                  {(results.length > 0 && searchTerm) && (
                                    <button onClick={() => setSearchTerm('')} className="clear-button">×</button>
                                  )}
                                </div>
                                {touched.profession && errors.profession && (
                                  <p className="error__feedback">{errors.profession}</p>
                                )}
                                {dropdownOpen && results.length > 0 && (
                                  <ul className="dropdown-results2" ref={dropdownRef}>
                                    {results.map((item) => (
                                      <li key={item.id} className="result-item">
                                        <div className="result-item-content">
                                          <span>{item.name}</span>
                                        </div>
                                        <button
                                          type="button"
                                          onClick={() =>
                                          {
                                            const newProfession = { id: item.id, name: item.name };
                                            const currentProfessions = values.profession
                                            if (!currentProfessions.some((prof) => prof.id === item.id))
                                            {
                                              handleChange({
                                                target: {
                                                  name: 'profession',
                                                  value: [...currentProfessions, newProfession],
                                                },
                                              });
                                            }
                                          }}
                                          className="add-button"
                                        >
                                          +
                                        </button>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="selected-items onboarding-selection">
                            {(values.profession && values.profession.length > 0) && (
                              <div className="selected-profession">
                                <label>Selected Professions:</label>
                                <div>
                                  {values.profession.map((professions) => (
                                    <div key={professions.id} className="selected-profession-item">
                                      {professions.name}
                                      <button
                                        type="button"
                                        onClick={() =>
                                        {
                                          const updatedProfessions = values.profession.filter(
                                            (item) => item.id !== professions.id
                                          );
                                          handleChange({
                                            target: {
                                              name: 'profession',
                                              value: updatedProfessions,
                                            },
                                          });
                                        }}
                                        className="remove-button"
                                      >
                                        ×
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="form-main" >
                            <div className='form-row'>
                              <div className="form-group">
                                <label>Job Title</label>
                                <div class="form-control-wrapper">
                                  <Input
                                    className="form-control"
                                    placeholder="Enter Job Title"
                                    name={"name"}
                                    value={values.name}
                                    onChange={handleChange}
                                  />
                                </div>
                                {touched.title && errors.title && (
                                  <p className="error__feedback">{errors.title}</p>
                                )}
                              </div>
                              <div class="form-group">
                                <label>Postcode</label>
                                <div className="form-control-wrapper">
                                  <input
                                    className="form-control"
                                    placeholder="Postcode"
                                    name="postcode"
                                    value={values.postcode}
                                    onChange={(value) => handleChange({ target: { name: 'postcode', value: value.target.value } })}
                                    maxLength={4}
                                  />
                                </div>
                                {touched.postcode && errors.postcode && (
                                  <p className="error__feedback">{errors.postcode}</p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className='form-main'>
                            <div className='form-row'>
                              <div className='form-group'>
                                <label>Job Description</label>
                                <div className="form-control-wrapper">
                                  <Input.TextArea
                                    name="description"
                                    value={values.description}
                                    onChange={handleChange}
                                    placeholder="Enter Description"
                                    className="form-control"
                                    rows={4}
                                  />
                                </div>
                                {touched.description && errors.description && (
                                  <p className="error__feedback">{errors.description}</p>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Time and Budget Section............................................................ */}

                          <div className='form-main'>
                            <div className='form-row'>
                              <div className='form-group'>
                                <label>Do you have a budget in mind?</label>
                                <div className="form-control-wrapper form-input-icon">
                                  <Input
                                    className="form-control"
                                    placeholder="Enter budget amount"
                                    name="budgetAmount"
                                    min={0}
                                    value={values.budgetAmount}
                                    onChange={(value) => handleChange({ target: { name: 'budgetAmount', value: value.target.value } })}
                                  />
                                  <span>$</span>
                                </div>
                                {touched.budgetAmount && errors.budgetAmount && (
                                  <p className="error__feedback">{errors.budgetAmount}</p>
                                )}
                              </div>

                              <div className='form-group '>
                                <label>Select a Budget</label>
                                <div>
                                  <select
                                    name="budget"
                                    className='form-control'
                                    placeholder="Select Budget"
                                    mode="single"
                                    value={values.budget}
                                    bordered={false}
                                    onChange={(value) => handleChange({ target: { name: 'budget', value: value.target.value } })}
                                  >
                                    <option>Select Budget</option>
                                    <option value={"Under $100"}>Under $100</option>
                                    <option value={"$100 - $500"}>$100 - $500</option>
                                    <option value={"$500 - $1000"}>$500 - $1000</option>
                                    <option value={"$1000 - $2000"}>$1000 - $2000</option>
                                    <option value={"$2000 - $5000"}>$2000 - $5000</option>
                                  </select>
                                </div>
                                {touched.budget && errors.budget && (
                                  <p className="error__feedback">{errors.budget}</p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="form-main">
                            <div className="form-row">
                              <div className="form-group">
                                <label>When do you need this job done by?</label>
                                <div className="select-check-radio">
                                  <div
                                    className={`profession-type-button ${selectedOption === "Urgently" ? "selected" : ""}`}
                                    onClick={() => handleOptionClick("Urgently")}
                                  >
                                    Urgently
                                  </div>
                                  <div
                                    className={`profession-type-button ${selectedOption === "Within 1 week" ? "selected" : ""}`}
                                    onClick={() => handleOptionClick("Within 1 week")}
                                  >
                                    Within 1 week
                                  </div>
                                  <div
                                    className={`profession-type-button ${selectedOption === "2 weeks or longer" ? "selected" : ""}`}
                                    onClick={() => handleOptionClick("2 weeks or longer")}
                                  >
                                    2 weeks or longer
                                  </div>
                                  <div
                                    className={`profession-type-button ${selectedOption === "Pick a Date" ? "date-selected selected" : ""}`}
                                    onClick={() => handleOptionClick("Pick a Date")}
                                  >
                                    {selectedOption === "Pick a Date" ? (
                                      <input type="date" name="deadlineDate"
                                        className="profession-type-button"
                                        disabledDate={(current) => current && current < moment().startOf("day")}
                                        placeholder="DD/MM/YYYY"
                                        value={date}
                                        onChange={(dateValue) => setDate(dateValue.target.value)} />
                                    ) : (
                                      "Pick a Date"
                                    )}
                                  </div>
                                </div>
                                {optionError && (
                                  <p className="error__feedback">{optionError}</p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="form-main">
                            <div className="form-row">
                              <div className="form-group">
                                <label>Site Visit Times</label>
                                <select
                                  className="form-control"
                                  bordered={false}
                                  name="siteVisit"
                                  placeholder="Select"
                                  mode="single"
                                  value={values.siteVisit}
                                  onChange={(value) => handleChange({ target: { name: 'siteVisit', value: value.target.value } })}
                                >
                                  <option>Select theme</option>
                                  <option value={"Anytime"}>Anytime</option>
                                  <option value={"Weekdays"}>Weekdays</option>
                                  <option value={"After business hours"}>After business hours</option>
                                  <option value={"Weekends"}>Weekends</option>
                                  <option value={"No site visit"}>No site visit</option>
                                </select>
                                {touched.siteVisit && errors.siteVisit && (
                                  <p className="error__feedback">{errors.siteVisit}</p>
                                )}
                              </div>
                            </div>
                          </div>


                          {/* Upload Media Section */}
                          <div className="form-main">
                            <div className={"form-row"}>
                              <div className="form-group">
                                <label>
                                  Upload images of the job to help businesses provide quotes
                                </label>


                                <div className="upload_image d-flex justify-content-between w-100">
                                  <div className='upload_image-drag-before'>
                                    <div
                                      className={`upload_image-drag ${isDragging ? 'dragging' : ''}`}
                                      onDragOver={handleDragOver}
                                      onDragEnter={handleDragEnter}
                                      onDragLeave={handleDragLeave}
                                      onDrop={handleDrop}
                                    >
                                      <p className='upload_image-drag-p'>
                                        Drag and Drop file here
                                      </p>
                                    </div>
                                  </div>
                                  <div className='upload_image-btn'>
                                    <p className='upload_image-btn-p' onClick={handleFileSelectClick}>
                                      Browse Files</p>
                                  </div>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRefs}
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleFileChange(e.target.files[0])}
                                  />

                                </div>

                              </div>
                            </div>
                            <div className="image_section">
                              {uploadedImages.map((image, index) => (
                                <div key={index} className="image_slot">
                                  <img src={image?.url || DummyUploadImage} alt={`Uploaded ${index}`} className="image_box" />
                                  {image?.url ? (<svg className='close-icon' xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="16" height="16" onClick={() => handleRemoveFile(image, index)}>
                                    <path d="M18,6h0a1,1,0,0,0-1.414,0L12,10.586,7.414,6A1,1,0,0,0,6,6H6A1,1,0,0,0,6,7.414L10.586,12,6,16.586A1,1,0,0,0,6,18H6a1,1,0,0,0,1.414,0L12,13.414,16.586,18A1,1,0,0,0,18,18h0a1,1,0,0,0,0-1.414L13.414,12,18,7.414A1,1,0,0,0,18,6Z" />
                                  </svg>) : null}
                                </div>
                              ))}
                            </div>

                            <div className='button_section onboarding-form-button'>
                              <button type="button" onClick={handleGoBack}>Go Back</button>

                              <button type="button" onClick={handleSubmit}>{duplicate === 0 ? `Save Changes` : `Duplicate Jobs`}</button>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </section>
                </form>
              )}
            </Formik>
            {successPopup && (
              <SuccessPopup onClose={closeSuccessPopup} message={"Job Saves Successfully"} />
            )}
            {!successPopup && (
              <></>
            )}

            {isErrorWindow && (
              <ErrorWindow onClose={closeErrorWindow} />
            )}
            {!isErrorWindow && (
              <></>
            )}
          </div >
        </div>
      </div>
      {isLoading &&
        <Loader />
      }
      {!isLoading && (
        <></>
      )}
    </>
  )
}

export default TabJobDetail